/**
 * Pack-page offer status helpers.
 *
 * The backend's `pool_offer.status` is a string. We treat `'available'` as
 * the only purchasable state — everything else puts the page into a
 * read-only mode (hero is dimmed, status badge appears, bottom action bar
 * is hidden).
 */

export const AVAILABLE_STATUS = 'available';

export function isOfferAvailable(status: string | null | undefined): boolean {
  return (status ?? AVAILABLE_STATUS) === AVAILABLE_STATUS;
}

const STATUS_LABEL: Record<string, string> = {
  // The backend has no sold-out state: a pack whose stock ran out is
  // `restocking`, and partners call that "Sold out" (Betr, 2026-10-28).
  restocking: 'Sold out',
  restoring: 'Restoring',
  sold_out: 'Sold out',
  coming_soon: 'Coming soon',
  paused: 'Paused',
};

/** Human-friendly badge label for non-available statuses. */
export function statusLabel(status: string | null | undefined): string {
  if (!status) return 'Restoring';
  if (STATUS_LABEL[status]) return STATUS_LABEL[status]!;
  return status
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
